import { OverflowTooltip } from '@/components/ui/OverflowTooltip';
import type { PickListOption } from '@/lib/api/types/picklistOption';

export const PickListCell = ({ value }: { value?: PickListOption }) =>
  value?.name && <OverflowTooltip>{value.name}</OverflowTooltip>;
